import { ServiceDependencies } from 'lib/core/services/magento'
import { axiosClient } from 'lib/core/services/magento/client'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import { AxiosResponse } from 'axios'

export interface CmsPageQueryObject {
  cmsPage: {
    __args: {
      identifier: string
    }
    url_key: boolean
    title: boolean
    content: boolean
    content_heading: boolean
    page_layout: boolean
    meta_title: boolean
    meta_description: boolean
    meta_keywords: boolean
  }
}

export const cmsPageQueryObject: CmsPageQueryObject = {
  cmsPage: {
    __args: {
      identifier: ''
    },
    url_key: true,
    title: true,
    content: true,
    content_heading: true,
    page_layout: true,
    meta_title: true,
    meta_description: true,
    meta_keywords: true
  }
}

interface CmsPageQueryInput {
  identifier: string
}

export type GetCmsPageQuery = (input: CmsPageQueryInput) => Promise<AxiosResponse<any>>

export const createCmsPageQuery = ({ getQueries }: ServiceDependencies): GetCmsPageQuery => async (input) => {
  const query = getQueries().cmsPageQuery
  query.cmsPage.__args.identifier = input.identifier

  return axiosClient(jsonToGraphQLQuery(query), true)
}
